import { Dayjs } from "dayjs";

export type WorkoutItem = {
  day: number;
  month: number;
  year: number;
  date: Dayjs;
  isCurrentDay: boolean;
};

export enum WorkoutType {
  running = 1,
  cycling,
  swimming,
  powerTraining,
}

export enum TrainingTypes {
  running = "running",
  cycling = "cycling",
  swimming = "swimming",
  powerTraining = "powerTraining",
}

export const TrainingTypesLabels: Record<TrainingTypes, string> = {
  [TrainingTypes.running]: "Бег",
  [TrainingTypes.cycling]: "Велосипед",
  [TrainingTypes.swimming]: "Плавание",
  [TrainingTypes.powerTraining]: "Силовая",
};

export enum WorkoutPlanType {
  plan = 1,
  fact,
}

export enum ScrollDirection {
  top = 1,
  bottom = 2,
}

export enum TrainingStatus {
  Failed = "failed",
  Complete = "complete", 
  Flawed = "flawed",
  InFuture = "inFuture",
  NotPlanned = "notPlanned",
}

export type CalendarEventManager = {
  onTodayClick: () => void;
  onDateClick: (date: Dayjs) => void;
};
